import type { DisconnectSlackMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

const mapTrpcResponseToGraphQL = (trpcData: {
  message: string;
}): DisconnectSlackMutation => ({
  disconnectSlack: {
    __typename: 'DisconnectSlackOutput',
    message: trpcData.message,
  },
});

export const useDisconnectSlackTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...trpc.frontend.notifications.slack.disconnect.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.notifications.slack.getConnection.queryKey(),
        });
      },
    }),
  });

  return {
    disconnectSlack: async (): Promise<DisconnectSlackMutation> => {
      const result = await mutation.mutateAsync();

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
